import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmail } from '../services/authService';

interface UseEmailSignInReturn {
  isLoading: boolean;
  error: string | null;
  handleEmailSignIn: (email: string, password: string) => Promise<void>;
}

export const useEmailSignIn = (): UseEmailSignInReturn => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const handleEmailSignIn = async (email: string, password: string) => {
    try {
      setIsLoading(true);
      setError(null);
      await signInWithEmail(email, password);
      navigate('/chat');
    } catch (error: any) {
      console.error('Error during email sign in:', error);
      setError(error.message || 'Failed to sign in');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    handleEmailSignIn
  };
};